export default {
  dashboard: '/portal/finance/',
}
